import React, { useEffect, useState } from "react";
import "../css/dashboard.scss";
import Header from "../components/header/Header";
import { TableRow } from "@mui/material";
import { getPartnerFilms, getPartnerMe } from "../services/partner";

// Films dashboard — backed by GET /api/partner/stats/films.
// Each row is one partner-owned film with hit/cash/part/percent. The page
// summary (total_hits / total_part / total_share) comes back in the same
// payload. Partner-level totals (total_earned / total_paid) come from
// /api/partner/me.
const Dashboard = () => {
  const [rows, setRows] = useState([]);
  const [summary, setSummary] = useState({ total_hits: 0, total_part: 0, total_share: 0 });
  const [me, setMe] = useState({ total_earned: 0, total_paid: 0 });

  useEffect(() => {
    getPartnerFilms().then((res) => {
      setRows(res.data.data || []);
      setSummary(res.data.summary || { total_hits: 0, total_part: 0, total_share: 0 });
    });
    getPartnerMe().then((res) => {
      setMe(res.data || {});
    });
  }, []);

  const residual = (me.total_earned || 0) - (me.total_paid || 0);

  return (
    <div className="box">
      <Header />
      <div className="filter"></div>
      <div className="all-center">
        <div className="box-table">
          <table>
            <tbody>
              <tr className="text-center">
                <th>IMAGE</th>
                <th>NAME</th>
                <th>PRICE PER VIEW</th>
                <th>PARTNER %</th>
                <th>VIEWS</th>
                <th>TOTAL PRICE</th>
                <th>PARTNER'S SHARE</th>
              </tr>

              {rows.map((row) => (
                <tr key={row.content_id}>
                  <td>
                    <img
                      width={60}
                      src={"https://media.metaflix.az/" + row.main_picture}
                      alt=""
                    />
                  </td>
                  <td>{row.name}</td>
                  <td>{row.cash} AZN</td>
                  <td>{row.percent} %</td>
                  <td>{row.hit}</td>
                  <td>{row.part} AZN</td>
                  <td>{((row.part || 0) * (row.percent || 0)) / 100} AZN</td>
                </tr>
              ))}

              <TableRow className="statis-box">
                <h5 className="txt1"> Ümumi : {me.total_earned} </h5>
                <h5 className="txt2"> Ödənildi : {me.total_paid} </h5>
                <h5 className="txt3"> Qalıq : {residual} </h5>
              </TableRow>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
